export default "__VITE_ASSET__C085u$yZ__"